import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/**
 * @Component <app-with-tooltip></<app-with-tooltip>
 * It does the following:
 *  - takes user onject details as input and shows data relevant to profile picture
 *  - If profile picture is not present, it would show the initials of users
 *  - Can be customized for further items
 *
 * @input :
 *
 *
 *
 * @usage
 * <app-profile-picture [name]="username" [userData]="userObject"> </app-profile-picture>
 */
@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
})
export class ProfilePictureComponent implements OnChanges {
  @Input() userData: any;
  @Input() name?: any;
  @Input() font?: string;
  initials: undefined;
  constructor() {}

  // this function checks the user name length and picks the first initial of the name
  // example: Peter Davidson = PD
  getUserInitials(name: any) {
    let userSegments = name && name?.split(' ');
    let firstInitial = userSegments[0]?.charAt(0);
    // if we have a longer name or a single name then this is checked on the basis of the array length of the split operation above
    // if there is a single name we pick the first and last letter of the name, to keep consistency
    let secondInitial =
      userSegments.length > 1
        ? userSegments[userSegments.length - 1].charAt(0)
        : userSegments[0].slice(-1);
    this.initials = (firstInitial + secondInitial).toUpperCase();
  }

  ngOnChanges(changes: SimpleChanges) {
    // This method is called whenever an input property changes
    // You can access the current and previous values in the changes object
    if (changes?.name?.currentValue) {
      const { currentValue, previousValue } = changes?.name;
      if (currentValue && currentValue !== previousValue) {
        this.getUserInitials(currentValue);
      }
    }
  }
}
